
Librarian.Session = new Class({
    Binds: ["onResetComplete", "onUpdateComplete", "onLogon", "onLogoff", "onFailure"],
    Implements: [Events, Options],

    options: {
    },

    initialize: function(options) {
        this.setOptions(options);
    },

    logon: function(username, password, params) {
        // Get current time zone
        var tz = -(new Date()).getTimezoneOffset() / 60;
        var url = Librarian.path.getMethodUrl("logon") + "&out=ujson&utz=" + tz.toString();

        if (params) {
            url += "&" + Librarian.Utils.getQueryString(params);
        }

        var data = {
            username: username,
            password: password
        };

        if (Librarian.sessionType == Librarian.Session.sessionTypes.onBehalf)
            // Pass onBehalfID (stored in userInfo) to stay logged in on behalf
            url += "&obuid=" + Librarian.userInfo.UserId;

        new Request.JSON({
            method: "post",
            urlEncoded: true,
            url: url,
            data: data,
            noCache: true,
            onSuccess: this.onLogon,
            onFailure: this.onFailure
        }).send();
    },

    logoff: function() {
        new Request({
            method: "get",
            url: Librarian.path.getMethodUrl("logoff"),
            noCache: true,
            onSuccess: this.onLogoff,
            onFailure: this.onFailure
        }).send();
    },

    changePassword: function(oldPassword, newPassword, securityQuestion, securityAnswer) {
        var url = Librarian.path.getUpdateUrl("setup") + "&out=cjson";

        var params = {
            uopw: oldPassword,
            unpw: newPassword
        }

        if (securityQuestion != null) {
            params.uq = securityQuestion;
            params.ua = securityAnswer;
        }

        new Request({
            url: url,
            method: "post",
            data: params,
            noCache: true
        }).addEvent("success", this.onUpdateComplete).addEvent("failure", this.onFailure).send();
    },

    sendResetPassword: function(username) {
        var url = Librarian.path.getRecoverUrl("sendresetpass") + "&out=cjson";

        var params = {
            name: username
        }

        new Request({
            url: url,
            method: "post",
            data: params,
            noCache: true
        }).addEvent("success", this.onSendResetPassword).send();
    },

    onSendResetPassword: function() {
        Librarian.Utils.notification("Password reset sent");
    },

    onUpdateComplete: function() {
        this.fireEvent("updatecomplete", arguments);
    },

    onLogon: function() {
        this.fireEvent("logon", arguments);
    },

    onLogoff: function() {
        this.fireEvent("logoff", arguments);
    },

    onFailure: function() {
        this.fireEvent("error", arguments);
    }
});

/* Static methods and variables */
Librarian.Session.extend({
    sessionTypes: {
        undefined: 0,
        user: 1,
        contactAsGuest: 2,
        userAsGuest: 3,
        anonymous: 4,
        onBehalf: 5,
        sso: 6
    },

    // Checks if the session is that of a user (type user or sso) or someone on behalf of a user (type onBehalf)
    isUser: function(sessionType) {
        return (sessionType == Librarian.Session.sessionTypes.user) ||
               (sessionType == Librarian.Session.sessionTypes.onBehalf) ||
               (sessionType == Librarian.Session.sessionTypes.sso);
    },

    isMfaRequired: function(xhr) {
        var value = xhr.getResponseHeader("X-MFA-Required");
        if (!value)
            return false;

        return value.toLowerCase() == "true";
    }
});

Librarian.Session.MFAPanel = new Class({
    Implements: [Events, Options],
    Binds: ["onLoadHtml", "submit", "onSuccess", "onFailure"],

    options: {
        container: null,
        mfaInfo: null,
        credentials: null,
        onSuccess: null
    },

    containerEl: null,
    wrapperEl: null,

    initialize: function(options) {
        this.setOptions(options);

        this.containerEl = $(this.options.container);

        this.loadHtml();
    },

    loadHtml: function() {
        var url = Librarian.path.getLayoutsPath() + "pages/mfapanel.html";

        var request = new Request.HTML({
            url: url,
            method: "get",
            append: this.containerEl,
            onSuccess: this.onLoadHtml
        });

        request.send();
    },

    onLoadHtml: function() {
        var mfaInfo = this.options.mfaInfo;

        this.wrapperEl = this.containerEl.getElement(".mfa-wrapper");

        if (mfaInfo.Status == "MfaSetupRequired") {
            var setupWrapper = this.wrapperEl.getElement(".mfa-setup-wrapper");
            if (setupWrapper)
                setupWrapper.show();

            var setupImg = this.wrapperEl.getElement(".mfa-setup-image");
            if (setupImg)
                setupImg.src = mfaInfo.ImageUrl;
        }

        this.codeInput = this.wrapperEl.getElement(".mfa-code-input");
        this.codeInput.focus();
        this.codeInput.addOnKeyPress("enter", this.submit);

        this.submitButton = this.wrapperEl.getElement(".mfa-code-submit");
        this.submitButton.addOnClick(this.submit);

        this.fireEvent("load");
    },

    toggleDisabled: function(disabled) {
        this.wrapperEl.toggleClass("disabled", disabled);
        this.codeInput.disabled = disabled;
        this.submitButton.disabled = disabled;
    },

    submit: function() {
        if (this.wrapperEl.hasClass("disabled"))
            return;

        this.toggleDisabled(true);

        var credentials = this.options.credentials;

        var params = {
            mfaSecret: this.options.mfaInfo.Secret,
            mfaCode: this.codeInput.value
        };

        var session = new Librarian.Session();
        session.onLogon = this.onSuccess;
        session.onFailure = this.onFailure;

        session.logon(credentials.username, credentials.password, params);
    },

    onSuccess: function(sessionInfo) {
        if (typeof this.options.onSuccess == "function")
            this.options.onSuccess(sessionInfo);
    },

    onFailure: function(xhr) {
        this.toggleDisabled(false);

        var status = null;

        if (Librarian.Session.isMfaRequired(xhr)) {
            var errorInfo = JSON.parse(xhr.responseText);
            status = errorInfo.Status;
        }

        var message = this.getErrorMessage(status);

        Librarian.Utils.error(message);
    },

    getErrorMessage: function(status) {
        switch(status) {
            case "MfaSetupRequired":
                return "Authenticator setup is required";
            case "MfaCodeRequired":
                return "Verification code is required";
            case "MfaInvalidCode":
                return "Verification code is invalid. Please try again.";
            default:
                return "An unexpected error occurred. Please try again.";
        }
    }
});
